import React from 'react';

const NoLettersContent = () => (
  <>
    <h2 className="vads-u-font-size--h3">No claim letters</h2>
    <div className="vads-u-font-size--lg">
      You don’t have any claim letters yet.
    </div>
  </>
);

export default NoLettersContent;
